'use strict';
var React = require('react');
var assetsHelper = require('../helper/assetsHelper');

var DesktopShell = React.createClass({
  propTypes: {
    title: React.PropTypes.string.isRequired,
    size: React.PropTypes.object.isRequired
  },
  render: function () {
    var shell = 'desktop-shell';
    var style = {
      width: this.props.size.width,
      height: this.props.size.height
    };
    var desktopContentStyle = {
      width: this.props.size.width - 2 * 8,
      height: this.props.size.height - 30 - 8
    };

    var desktopTitleStyle = {
      width: desktopContentStyle.width - 30,
      height: 30,
      position: 'absolute',
      left: 8,
      top: 0,
      lineHeight: '30px',
      color: '#FFFFFF',
      fontSize: 14
    };

    var desktopCloseStyle = {
      width: 20,
      height: 20,
      position: 'absolute',
      left: style.width - 28,
      top: 5
    };

    return (
      <div className='desktop-shell'
           style={style}>
        <div className="page-title" style={desktopTitleStyle}>{this.props.title}</div>
        <img className="close-btn" style={desktopCloseStyle} src={assetsHelper.getAsset('shell/close.png')}/>
        <div className="content-area" style={desktopContentStyle}></div>
      </div>
    );
  }
});

module.exports = DesktopShell;


/** WEBPACK FOOTER **
 ** ./src/views/DesktopShell.jsx
 **/